import { explatPlatform } from '@1debit/explat';

let isExPlatInitialized = false;

export const getIsExPlatInitialized = () => {
  return isExPlatInitialized;
};

/* eslint-disable */
/* tslint:disable */
export const initExPlat = () => {
  try {
    explatPlatform.init({
      debugMode: { log: true, raiseError: true },
      urls: {
        rest: '../',
      },
    });
    isExPlatInitialized = true;
  } catch (err) {
    const message = 'ExPlat initialization failed';
    const error = new Error(message);
    window.Rollbar?.error(error.message, error, err);
  }
};
